import React from 'react';
import { useT } from '../../i18n/LanguageContext';
import strings from './CopyrightPage.i18n';
import './LegalPage.css';

export default function CopyrightPage() {
  const t = useT(strings);
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="section" style={{ textAlign: 'center' }}>
          <p className="section-label">{t.sectionLabel}</p>
          <h1 className="section-title">{t.title}</h1>
          <p className="section-subtitle" style={{ margin: '0 auto' }}>
            {t.subtitle}
          </p>
        </div>
      </section>

      <section className="legal-content section">
        <div className="legal-section">
          <h2>{t.s1Title}</h2>
          <p>{t.s1p1}</p>
        </div>

        <div className="legal-section">
          <h2>{t.s2Title}</h2>
          <p>{t.s2p1}</p>
        </div>

        <div className="legal-section">
          <h2>{t.s3Title}</h2>
          <p>{t.s3p1}</p>
          <ul>
            {t.s3l1.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>

        <div className="legal-section">
          <h2>{t.s4Title}</h2>
          <p>{t.s4p1}</p>
        </div>

        <div className="legal-section">
          <h2>{t.s5Title}</h2>
          <p>{t.s5p1}</p>
        </div>

        <div className="legal-section">
          <h2>{t.s6Title}</h2>
          <p>{t.s6p1}</p>
        </div>

        <div className="legal-section">
          <h2>{t.s7Title}</h2>
          <p>{t.s7p1}</p>
          <ul>
            {t.s7l1.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>

        <div className="legal-section">
          <h2>{t.s8Title}</h2>
          <p>{t.s8p1}</p>
          <p>noreply@mampuai.com</p>
          <p>63-4B, Tingkat 4, Jalan Anggerik Vanilla T 31/T, Kota Kemuning, 40460 Shah Alam, Selangor</p>
        </div>
      </section>
    </div>
  );
}
